import Api from '@/services/Api'

export default {
  getSubscribedChannels(subscriberId) {
    return Api().get('accounts/myye/video-channels', {
      params: {
        subscriberId,
        select: 'channelId'
      }
    })
  },
  getSubscribers(limit) {
    return Api().get('subscriptions/subscribers', {
      params: {
        limit
      }
    })
  },
  checkSubscription(data,id) {
    return Api().get('users/me/subscriptions/exist',{
      params: {
        uris:id
      }
     })
  },
  // getAll(data, params) {
  //   return Api().get(`videos`, {
  //     params
  //   })
  // },
  createSubscription(data) {
    return Api().post('subscriptions', data)
  },
  getSubscribedVideos(page) {
    return Api().get('users/me/subscriptions/videos', {
      params: {
        start:page,
        count: 10
      }
    })
  }
}
